import { type FC, useMemo } from "react";

import type { ProductGalleryAsset } from "@jti/fe-common";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ProductCarousel } from "@product-details/components/ProductCarousel";
import { useConsumablesProductDetailsContext } from "@product-details/providers/ConsumablesProductDetailsProvider";
import { getFilteredImagesByRole } from "@product-details/utils/getFilteredImagesByRole";

export const ConsumablesProductCarousel: FC = () => {
  const { currentMatrixItem } = useConsumablesProductDetailsContext();
  const { __ } = useTranslations();

  const productGalleryItems: ProductGalleryAsset[] = useMemo(() => {
    const mediaGallery = currentMatrixItem.product.mediaGallery;
    const computedProductGalleryItems = mediaGallery.map(({ url, ...item }) => ({
      ...item,
      path: url,
    }));

    return getFilteredImagesByRole(computedProductGalleryItems, "dynamic_picture_bundle");
  }, [currentMatrixItem.sku, currentMatrixItem.product.mediaGallery]);

  return (
    <ProductCarousel
      items={productGalleryItems}
      key={currentMatrixItem.sku}
      seekLabel={__("productdetails.carousel.video.seek")}
      volumeLabel={__("productdetails.carousel.video.volume")}
      playLabel={__("productdetails.carousel.video.play")}
      replayLabel={__("productdetails.carousel.video.replay")}
      muteLabel={__("productdetails.carousel.video.mute")}
      soundOnLabel={__("productdetails.carousel.video.unmute")}
      showFullscreenLabel={__("productdetails.carousel.video.fullscreen")}
      previousSlideLabel={__("productdetails.carousel.previous_slide")}
      nextSlideLabel={__("productdetails.carousel.next_slide")}
    />
  );
};
